import React, { FunctionComponent, useEffect, useState } from "react";
import * as yup from 'yup';
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import styles from '../Analytics/Analytics.module.css'
import Loading from "../../Components/Loading/Loading";
import axios from "axios";
import moment from "moment";
import { url } from "../../Values/constants";
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { OutlinedInputProps } from '@mui/material/OutlinedInput';
import { Grid, Button, Typography, Select, MenuItem, Card, CardMedia, Avatar } from "@mui/material";
import './booking.style.css';
import { FileUpload } from "@mui/icons-material";
import { DropzoneArea } from 'material-ui-dropzone';
import { DropzoneDialog } from 'material-ui-dropzone'
import { green } from '@mui/material/colors';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useLocation } from "react-router";
import { v4 as uuidv4 } from 'uuid';
import { showSnackbarAction } from "../../Redux/actions";
import { makeStyles } from "@material-ui/core";
import { themeColors } from "../../Components/theme";

const CssTextField = styled(TextField)({
    fontSize: "0.8rem"
});
// const arrAdditionalCharges = [
//     {
//         value: 'Club Membership',
//         label: 'Club Membership'
//     },
//     {
//         value: 'Dual Electric Meter Charges',
//         label: 'Dual Electric Meter Charges'
//     },
//     {
//         value: 'EDC',
//         label: 'EDC'
//     },
//     {
//         value: 'EEC',
//         label: 'EEC'
//     },
//     {
//         value: 'FFC',
//         label: 'FFC'
//     },
//     {
//         value: 'Gas Connection',
//         label: 'Gas Connection'
//     },
//     {
//         value: 'IFMS',
//         label: 'IFMS'
//     },
//     {
//         value: 'Lease Rent',
//         label: 'Lease Rent'
//     },
//     {
//         value: 'Others',
//         label: 'Others'
//     },
//     {
//         value: 'Parking Covered',
//         label: 'Parking Covered'
//     },
//     {
//         value: 'Parking Open',
//         label: 'Parking Open'
//     },
//     {
//         value: 'Parking Stilt',
//         label: 'Parking Stilt'
//     },
//     {
//         value: 'PLC Corner',
//         label: 'PLC Corner'
//     },
//     {
//         value: 'PLC Floor',
//         label: 'PLC Floor'
//     },
//     {
//         value: 'PLC Green',
//         label: 'PLC Green'
//     },
//     {
//         value: 'PLC Pool',
//         label: 'PLC Pool'
//     },
//     {
//         value: 'Power Backup',
//         label: 'Power Backup'
//     },
//     {
//         value: 'Stamp Duty',
//         label: 'Stamp Duty'
//     },
//     {
//         value: 'Registration Charges',
//         label: 'Registration Charges'
//     },
//     {
//         value: 'PLC Road',
//         label: 'PLC Road'
//     }
// ];
type props = {
    //   history: any;
    //   user: any;
    formikProps: any;
    theme:any;
};
const EditConsolidatedCosting: FunctionComponent<props> = ({ formikProps,theme }) => {
    const [totalAdditionalCharges, setTotalAdditionalCharges] = useState<any>();
   // # New start
    const [isGstFocused, setIsGstFocused] = useState(false);
  const [isGstAmountFocused, setIsGstAmountFocused] = useState(false);
  // # New start
    const totalAddCharges = formikProps.values.additional_charges?.total_additional_charges;
    const area = formikProps.values.area;
    const bSP = formikProps.values.property_details_BSP?.bsp;
    const bspDiscountAmount = formikProps.values.property_details_BSP?.bsp_discount_amount;
    const gstAmount = formikProps.values.consolidated_costing?.gst_amount;
    // # New start
    const gst = formikProps.values.consolidated_costing?.gst;
    // # New start

    useEffect(() => {
        formikProps.setFieldValue("consolidated_costing.total_additional_charges", totalAddCharges);
    }, [totalAddCharges]);

    useEffect(() => {
      // (BSP-BSP_Discount_Area)*Area
        const netBSPArea = (parseInt(bSP) - parseInt(bspDiscountAmount)) * parseInt(area);
        // (BSP-BSP_Discount)*Area+(Total Additional Amount)
        const grossPropertyCostApplicant = ((parseInt(bSP) - parseInt(bspDiscountAmount)) * parseInt(area)) + parseInt(totalAddCharges);
        // GSTAMOUNT/((BSP-BSPDISCOUNT)*(Area+Totalamount))*100
        const gst = parseInt(gstAmount) / grossPropertyCostApplicant * 100;
        // (BSP-BSP_Discount)*Area+(Total Additional Amount)+(GST Amount)
        const netPropertyCostToApplicant = grossPropertyCostApplicant + parseInt(gstAmount);
        // console.log("netPropertyCostToApplicant",netPropertyCostToApplicant);
        formikProps.setFieldValue("consolidated_costing.net_bsp_area", netBSPArea);
        formikProps.setFieldValue("consolidated_costing.gross_property_cost_applicant", grossPropertyCostApplicant);
        formikProps.setFieldValue("consolidated_costing.gst", gst);
        formikProps.setFieldValue("consolidated_costing.net_property_cost_applicant", netPropertyCostToApplicant);
    }, [area])
    // # New start
    useEffect(() => {
      
      if (isGstFocused){ // GSTAMOUNT/((BSP-BSPDISCOUNT)*(Area+Totalamount))*100
      const grossPropertyCostApplicant = ((parseInt(bSP) - parseInt(bspDiscountAmount)) * parseInt(area)) + parseInt(totalAddCharges);
      // GSTAMOUNT/((BSP-BSPDISCOUNT)*(Area+Totalamount))*100h
      // const gst = parseInt(gstAmount) / grossPropertyCostApplicant * 100;
      const gstAmount = parseInt(gst) / 100 *grossPropertyCostApplicant;
        // (BSP-BSP_Discount)*Area+(Total Additional Amount)+(GST Amount)
        const netPropertyCostToApplicant = grossPropertyCostApplicant + (parseInt(gst) / 100 *grossPropertyCostApplicant);
        formikProps.setFieldValue("consolidated_costing.gst_amount", gstAmount.toFixed(2));
        formikProps.setFieldValue("consolidated_costing.net_property_cost_applicant", netPropertyCostToApplicant);}
    }, [gst])
    useEffect(() => {
      // # New start
      if (isGstAmountFocused){ 
      // GSTAMOUNT/((BSP-BSPDISCOUNT)*(Area+Totalamount))*100
      const grossPropertyCostApplicant = ((parseInt(bSP) - parseInt(bspDiscountAmount)) * parseInt(area)) + parseInt(totalAddCharges);
      // GSTAMOUNT/((BSP-BSPDISCOUNT)*(Area+Totalamount))*100
      const gst = parseInt(gstAmount) / grossPropertyCostApplicant * 100;
        // (BSP-BSP_Discount)*Area+(Total Additional Amount)+(GST Amount)
        const netPropertyCostToApplicant = grossPropertyCostApplicant + parseInt(gstAmount);
        formikProps.setFieldValue("consolidated_costing.gst", gst.toFixed(2));
        formikProps.setFieldValue("consolidated_costing.net_property_cost_applicant", netPropertyCostToApplicant);
      } // # New start
    }, [gstAmount])

    const useHelperTextStyles = makeStyles(() => ({
        inputRoot: {
          // "&$disabled": {
          //   color: "green"
          // }
        },
        disabled: {
        },
        root: {
          "& .MuiFormLabel-root": {
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiFormLabel-root.Mui-disabled": {
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiSelect-select":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiSelect-select.Mui-disabled":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiInputBase-input":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiInputBase-input.Mui-disabled":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
            "-webkit-text-fill-color":  `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiOutlinedInput-input":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiOutlinedInput-input.Mui-disabled":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
          },
          "& .MuiSvgIcon-root":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
        },
        "& .MuiSvgIcon-root.Mui-disabled":{
            color: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark}`,
        }
        },
        notchedOutline:{
          borderWidth: "1px",
          borderColor: `${theme ? themeColors.textPrimary : themeColors.textPrimaryDark} !important`,
        },
        preview: {
          color:"black"
        },
        dropzone:{
          color:"black"
        },
        formHelperText:{
        },
      }));
      const helperTextStyles = useHelperTextStyles();
    return (
        <>
            <div style={{
                border: "solid 1px #AEAEAE",
                boxShadow: "rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
                borderRadius: "10px",
                padding: "10px",
            }}>
                <Grid container className="booking_container" spacing={2} style={{ padding: "30px" }} >
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            label="Net BSP *Area"
                            size="small"
                            disabled
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.net_bsp_area')}
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            label="Total Additional Charges"
                            size="small"
                            disabled
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.total_additional_charges')}
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            label="Gross Property Cost To Applicant"
                            size="small"
                            disabled
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.gross_property_cost_applicant')}
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            label="GST Amount"
                            size="small"
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.gst_amount')}
                            // # New start
                            onBlur={() => setIsGstAmountFocused(false)}
                            onFocus={() => setIsGstAmountFocused(true)}
                            // # New start
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            // disabled
                            label="GST %"
                            size="small"
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.gst')}
                            // # New start
                            onBlur={() => setIsGstFocused(false)}
                            onFocus={() => setIsGstFocused(true)}
                            // # New start
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            disabled
                            label="Net Property Cost To Applicant"
                            size="small"
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.net_property_cost_applicant')}
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                    <Grid item xs={3}>
                        <CssTextField
                            type="text"
                            fullWidth
                            required
                            label="Minimum Booking Amount"
                            size="small"
                            id="custom-css-outlined-input"
                            {...formikProps.getFieldProps('consolidated_costing.minimum_booking_amount')}
                            className={helperTextStyles.root}
                            InputProps={{
                              classes: {
                                notchedOutline: helperTextStyles.notchedOutline
                              }
                            }}
                            sx={{ input: { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark } }}
                        >
                        </CssTextField>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode
    };
};
export default connect(mapStateToProps)(EditConsolidatedCosting);